var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Layer_1",
    enableBackground: "new 0 0 25 25",
    height: 512,
    viewBox: "0 0 25 25",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.5 1c-6.4 0-11.5 5.1-11.5 11.5s5.1 11.5 11.5 11.5 11.5-5.1 11.5-11.5-5.1-11.5-11.5-11.5zm4 14.4c-.3.4-1 .5-1.4.1l-3.2-2.6c-.2-.2-.4-.5-.4-.8v-5.6c0-.6.5-1 1-1 .6 0 1 .4 1 1v5.2l2.8 2.3c.5.4.5 1 .2 1.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d27fe9e2eab119fee73c5e28705af2cd.svg";
export { ForwardRef as ReactComponent };